export default "__VITE_ASSET__v8nh0lW1__"